import React, { Suspense, lazy } from 'react';
import { Provider } from 'react-redux';
import { Skeleton } from 'antd';
import { HashRouter, Route, Switch } from "react-router-dom";

import './api';
import store from './store';
import { Header, Footer } from './components';

const Home = lazy(() => import('./pages/Home/Home'));
const Auth = lazy(() => import('./pages/Auth/Auth'));
const About = lazy(() => import('./pages/About/About'));
const Video = lazy(() => import('./pages/Video/Video'));
const Personal = lazy(() => import('./pages/Personal/Personal'));
const LiveRoom = lazy(() => import('./pages/LiveRoom/LiveRoom'));
const Rules = lazy(() => import('./pages/Rules/Rules'));
const PageNotFound = lazy(() => import('./pages/PageNotFound/PageNotFound'));

function App() {
  return (
    <Provider store={store}>
      <HashRouter>
        <>
          <Header />
          <Suspense fallback={<div className='main'><Skeleton active /></div>}>
            <Switch>
              <Route exact path="/" component={Home}/>
              <Route exact path="/auth/:auth(login|registered|forget-password)" component={Auth}/>
              <Route exact path="/live-room/:id" component={LiveRoom} />
              <Route exact path="/video/:id" component={Video} />
              <Route path="/personal" component={Personal} />
              <Route exact path='/about' component={About} />
              <Route path='/rules' component={Rules} />
              <Route component={PageNotFound} />
            </Switch>
          </Suspense>
          <Footer />
        </>
      </HashRouter>
    </Provider>
  );
}

export default App;
